<template>
  <b-card>
    <!-- Cabecera -->
    <div slot="header">
      <strong>Ticket <span class="badge badge-primary p-2">{{ ticket_detalle.idTicket }}</span></strong>
      <b-button
          class="float-right"
          size="sm"
          variant="secondary"
          to="/tickets">
        <i class="fa fa-reply fa-lg mr-1"></i>Volver
      </b-button>
    </div>

    <!-- Contenido -->
    <b-card-text>

      <div>
        <strong>Empresa: </strong>
        {{ticket_detalle.empresa}}
      </div>

      <div class="my-2 d-flex">
        <strong>Asunto: </strong>
        <div class="ml-1" v-if="getNameTypeMatter(ticket_detalle.type_matter).length > 0">
          <span v-for="(item, index) of getNameTypeMatter(ticket_detalle.type_matter)" :key="item.id" class="mb-1">
            {{ item.label }}
            <span class="mx-1" v-show="index < (getNameTypeMatter(ticket_detalle.type_matter).length-1)">|</span>
          </span>
        </div>
        <span v-else class="ml-1">No registra</span>
      </div>

      <div class="my-2" v-show="ticket_detalle.name_product">
        <strong>Nombre del producto: </strong>
        {{ (ticket_detalle.name_product && ticket_detalle.name_product !== 'undefined') ? ticket_detalle.name_product : 'N/A' }}
      </div>

      <div class="my-2">
        <strong>Nombre del producto / # Solicitud: </strong>
        {{ ticket_detalle.asunto || 'No registra' }}
      </div>

      <div class="my-2">
        <strong>Fabricante: </strong>
        {{ (ticket_detalle.manufacturer && typeof ticket_detalle.manufacturer === 'object') ? ticket_detalle.manufacturer.nombre : 'No registra' }}
      </div>

      <div class="my-2 d-flex">
        <strong>Ubicaciones: </strong>
        <div class="ml-1" v-if="(getLocationsTicket && typeof getLocationsTicket === 'object' && getLocationsTicket.length > 0)">
          <span v-for="(location, index) of getLocationsTicket" :key="location.id" class="mb-1">
            <b-badge :style="{ background: getBackgroundColorLocation(location.id)}">{{ location.description }} </b-badge>
            <span class="mx-1" v-show="index < (ticket_detalle.locations.length-1)">|</span>
          </span>
        </div>
        <span class="ml-1" v-else>No registra</span>
      </div>

      <div v-show="ticket_detalle.temporary_location" class="my-2">
        <strong>Ubicación temporal: </strong>
        {{ (ticket_detalle.temporary_location && ticket_detalle.temporary_location.name != 'undefined') ? ticket_detalle.temporary_location.name : 'No registra' }}
      </div>

      <div class="my-2">
        <strong>Mensaje: </strong>
        {{ ticket_detalle.mensaje || 'No registra' }}
      </div>

      <div class="my-2" v-if="ticket_detalle.custom_field_id">
        <strong>Campo personalizado: </strong>
        {{ ticket_detalle.custom_field_name || 'No registra' }} - {{ ticket_detalle.custom_field_value }}
      </div>

    </b-card-text>

    <b-card-text>
      <hr>
      <h5>Detalles del usuario</h5>

      <div class="mt-2">
        <strong>Nombre: </strong>
        {{ ticket_detalle.nombre }}
      </div>

      <div>
        <strong>Correo electronico: </strong>
        {{ ticket_detalle.email }}
      </div>
    </b-card-text>

    <b-card-text>
      <hr>
      <h5>Detalles de fechas</h5>

      <div class="mt-2">
        <strong>Enviado: </strong>
        {{ ticket_detalle.created_at }}
      </div>
    </b-card-text>

    <b-card-text v-if="ticket_detalle.temporary_location">
      <hr>
      <h5>Ubicacion temporal</h5>

      <div class="mt-2">
        <div v-if="getTemporaryLocationPath()" class="location-item">
          <i class="fa fa-map-marker-alt location-icon"></i>
          <span
            class="location-path"
            v-b-tooltip.hover.top="getTemporaryLocationPath()"
          >
            {{ getTemporaryLocationPath() }}
          </span>
        </div>
        <div v-else class="location-item">
          <i class="fa fa-map-marker-alt location-icon"></i>
          <span class="location-path">
            {{ (ticket_detalle.temporary_location && ticket_detalle.temporary_location.name != 'undefined') ? ticket_detalle.temporary_location.name : 'No registra' }}
          </span>
        </div>
      </div>
    </b-card-text>
    
    <b-card-text v-else>
      <hr>
      <h5>Ubicación</h5>

      <div class="mt-2">
        <div v-if="ticket_detalle.locations && ticket_detalle.locations.length > 0">
          <div v-for="id in ticket_detalle.locations" :key="id" class="location-item">
            <i class="fa fa-map-marker-alt location-icon"></i>
            <span
              class="location-path"
              v-b-tooltip.hover.top="formatLocationPath(id)"
            >
              {{ formatLocationPath(id) }}
            </span>
          </div>
        </div>
        <div v-else>
          No hay ubicaciones asignadas.
        </div>
      </div>
    </b-card-text>

    <!-- Botones de acciones -->
    <div class="d-flex justify-content-end align-items-center">
      <b-button
          variant="primary"
          v-if="ticket_detalle.adjunto !== null"
          @click="descargaAdjunto(ticket_detalle)"
      >
        <i class="fa fa-download fa-lg icon"/>
        <span class="d-none d-md-inline-block ml-2"> Descargar</span>
      </b-button>
      <b-button @click="showModalCancelTicket"
                variant="danger"
                class="ml-2"
                v-if="usuarioEmpresa && ticket_detalle.estado_ticket && this.ticket_detalle.estado_ticket.lista != 'Cancelado'">
        <i class="fa fa-close fa-lg icon"/>
        <span class="d-none d-md-inline-block ml-1"> Cerrar ticket</span>
      </b-button>
    </div>

    <hr/>
    <b-row v-if="usuarioAdmin">
      <b-col md="6" sm="12">
        <b-form-group>
          <label for="estado">Estado</label>
          <b-form-select
              v-model="ticket_detalle.estado"
              :options="estados"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6" sm="12">
        <b-form-group>
          <label for="responsable">Responsable</label>
          <el-select
              size=""
              v-model="ticket_detalle.id_responsable"
              filterable
              clearable
              no-data-text="No hay datos que coincidan"
              no-match-text="No hay datos que coincidan"
          >
            <el-option
                v-for="usuario in usuarios.filter(item => item.text != 'Todos')"
                :key="usuario.value"
                :label="usuario.text"
                :value="usuario.value"
            >
            </el-option>
          </el-select>
        </b-form-group>
      </b-col>
      <b-col md="12" sm="12">
        <b-form-group>
          <div v-if="ticket_detalle.temporary_location">
            <label for="ubicacion">
              Digitar ubicación
              <b-form-checkbox
                  v-model="ticket_detalle.digit_location"
                  class="float-right ml-2"
                  @change="resetSelectedLocation"
                  v-b-tooltip.top.hover="'Ubicación temporal'"
                  :checked-value="true"
                  :unchecked-value="false"
              />
            </label>
          </div>
          <label v-else for="ubicacion">
            Ubicación
          </label>
          <b-form-input
              v-if="ticket_detalle.digit_location && ticket_detalle.temporary_location"
              v-model="ticket_detalle.ubicacion_diligenciada"
          />
     
          <div v-else>
            <div v-if="ticket_detalle.locations && ticket_detalle.locations.length > 0">
              <div v-for="id in ticket_detalle.locations" :key="id" class="location-item">
                  <i class="fa fa-map-marker-alt location-icon"></i>
                  <span
                    class="location-path"
                    v-b-tooltip.hover.top="formatLocationPath(id)"
                  >
                    {{ formatLocationPath(id) }}
                  </span>
              </div>
            </div>
            <div v-else>
              No hay ubicaciones asignadas.
            </div>
          </div>
        </b-form-group>
      </b-col>
      <b-col md="12" sm="12">
        <b-form-group>
          <label for="save"></label>
          <div class="text-right">
            <b-button
                variant="primary"
                @click="actualizarTicketDetalle(ticket_detalle)"
                class="mt-2"
            >
              <i class="fa fa-floppy-o"/>
              Guardar
            </b-button>
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <!--============================
        MODAL CONFIRM
    ==============================-->
    <ModalCloseTickect :ticket_detalle="ticket_detalle"/>

  </b-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import ModalCloseTickect from "@/views/tickets/ModalCloseTickect";

export default {
  name: "Ticket",
  components: {
    Treeselect,
    ModalCloseTickect
  },
  data() {
    return {
      value: null,
      locations: []
    }
  },
  created() {
    this.getLocations();
  },
  methods: {
    ...mapActions("tickets", ["descargarAdjunto", "actualizarTicket"]),
    ...mapMutations("tickets", ["cambiaTicketId",]),
    async descargaAdjunto(adj, tipo = "ticket") {
      adj.tipo = tipo;
      await this.descargarAdjunto(adj);
    },
    resetSelectedLocation() {
      this.cambiaTicketId({
        ubicacion_diligenciada: null,
        slq_locations_id: null
      });
    },
    normalizer(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    async actualizarTicketDetalle(ticket) {
      let data = {
        'id': ticket.id,
        'idTicket': ticket.idTicket,
        'estado': ticket.estado,
        'id_responsable': ticket.id_responsable,
        'ubicacion_diligenciada': ticket.ubicacion_diligenciada,
        'locations': ticket.locations
      };
      await this.actualizarTicket(data);
    },
    showModalCancelTicket() {
      this.$bvModal.show("modal_close_ticket");
    },
    /**
     * Obtener el nombre de los tipos de asuntos.
     *
     * @param String typeMatters
     * @returns
     */
     getNameTypeMatter(typeMatters) {
      let typeMattersText = [];
      if(typeof typeMatters === 'string' && typeMatters.length > 0 && typeMatters) {

          const data = JSON.parse(typeMatters);
          if (!(data && typeof data === 'object')) return [];

          data.map(type => {
              const typeMatterSearch = this.typesOfMatters.find(x => +x.id === +type)
              if (typeMatterSearch) typeMattersText.push(typeMatterSearch)
          })

          return typeMattersText;
      }

      return [];
    },
    getLocations() {
      const locations = this.ticket_detalle.locations;
      this.locations = (locations && typeof locations === 'object') ? locations.map(x => x.id) : []
    },
    getBackgroundColorLocation(id) {
      const location = this.findLocationById(this.arbolUbicaciones, id);
      if (!location || typeof location.location_level !== 'object' || !location.location_level) return "#ffffff";

      return location.location_level.color;
    },
    findLocationById(locations, id) {
      for (const location of locations) {
          if (location.id === id) return location;
          if (location.children && location.children.length > 0) {
              const result = this.findLocationById(location.children, id);
              if (result) return result;
          }
      }
      return null;
    },
    formatLocationPath(id) {
      let path = [];
      const findNode = (nodes, id) => {
        for (let node of nodes) {
          if (node.id === id) return node;
          if (node.children && node.children.length > 0) {
            const found = findNode(node.children, id);
            if (found) return found;
          }
        }
        return null;
      };
      let current = findNode(this.arbolUbicaciones, id);
      while (current) {
        path.unshift(current.label);
        current = findNode(this.arbolUbicaciones, current.slq_location_id);
      }
      return path.join(" > ");
    },
    /**
     * Obtener la ruta de la ubicación temporal.
     */
    getTemporaryLocationPath() {
      if (!this.ticket_detalle.temporary_location || !this.ticket_detalle.temporary_location.name) {
        return null;
      }

      let parentLocationId = null;
      if (this.ticket_detalle.locations && this.ticket_detalle.locations.length > 0) {
        parentLocationId = this.ticket_detalle.locations[0];
      }

      if (!parentLocationId) {
        return this.ticket_detalle.temporary_location.name;
      }

      const parentPath = this.formatLocationPath(parentLocationId);
      
      return `${parentPath} > ${this.ticket_detalle.temporary_location.name}`;
    }
  },
  computed: {
    ...mapState("tickets", [
      "ticket_detalle",
      "estados",
      "usuarios",
      'typesOfMatters'
    ]),
    ...mapState('autenticacion', ['usuarioAdmin', 'usuarioEmpresa']),
    ...mapState("location", ["arbolUbicaciones"]),
    getLocationsTicket() {
      return this.ticket_detalle.list_locations
    },
  }
}
</script>

<style scoped>
.location-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  white-space: nowrap;
}

.location-icon {
  color: #097b83;
  margin-right: 8px;
  font-size: 14px;
}

.location-path {
  color: #606266;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}
</style>
